import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container flex" }
const _hoisted_2 = { class: "blue_box flex_4" }
const _hoisted_3 = { class: "box_tit _flex" }
const _hoisted_4 = { class: "info_box" }
const _hoisted_5 = { class: "col_blue" }
const _hoisted_6 = { class: "common_table" }
const _hoisted_7 = { class: "list_num" }
const _hoisted_8 = { class: "underline" }
const _hoisted_9 = { class: "cnt p_5" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "blue_box flex_3" }
const _hoisted_12 = { class: "box_tit _flex" }
const _hoisted_13 = { class: "pointer" }
const _hoisted_14 = { class: "info_box" }
const _hoisted_15 = { class: "col_blue" }
const _hoisted_16 = { class: "common_table mini_blue_box small_size" }
const _hoisted_17 = { class: "cnt" }
const _hoisted_18 = { class: "underline" }
const _hoisted_19 = { class: "total" }
const _hoisted_20 = {
  rowspan: "2",
  class: "cnt p_5"
}
const _hoisted_21 = { class: "common_table mini_blue_box small_size" }
const _hoisted_22 = { class: "cnt" }
const _hoisted_23 = { class: "underline" }
const _hoisted_24 = { class: "total" }
const _hoisted_25 = {
  rowspan: "2",
  class: "cnt p_5"
}
const _hoisted_26 = { class: "blue_box _flex mini_blue_box_wrap" }
const _hoisted_27 = { class: "mini_blue_box _full" }
const _hoisted_28 = { class: "sch_condition_wrap" }
const _hoisted_29 = { class: "left _flex _align_bottom" }
const _hoisted_30 = { class: "select_date_wrap _120" }
const _hoisted_31 = { class: "select_date" }
const _hoisted_32 = { class: "select_date" }
const _hoisted_33 = { class: "graph_wrap" }
const _hoisted_34 = { class: "mini_blue_box" }
const _hoisted_35 = { class: "common_table small_size" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "mini_blue_box" }
const _hoisted_38 = { class: "common_table small_size" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "mini_blue_box" }
const _hoisted_41 = { class: "common_table small_size" }
const _hoisted_42 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "답변 미완료 제보", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createTextVNode(" 총 ", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.noCommentState.totalLength) + "건", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", null, [
            _cache[7] || (_cache[7] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"80px"} }),
              _createElementVNode("col"),
              _createElementVNode("col", { style: {"width":"180px"} }),
              _createElementVNode("col", { style: {"width":"80px"} })
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "번호"),
                _createElementVNode("th", null, "게시판"),
                _createElementVNode("th", null, "작성일"),
                _createElementVNode("th", null, "답변여부")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              ($setup.noCommentState.list && $setup.noCommentState.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.noCommentState.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", _hoisted_7, _toDisplayString(($setup.noCommentState.page - 1) * $setup.noCommentState.size + idx + 1), 1),
                      _createElementVNode("td", _hoisted_8, [
                        _createVNode(_component_RouterLink, {
                          to: { name: item.type === 3 ? 'qnaList' : 'reportList', query: { type: item.type === 1 ? 1 : 2 } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.type === 1 ? "성매매 의심업소" : item.type === 2 ? "성매매 알선광고" : "[1:1 문의] " + item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(item.type === 3 ? "미완료" : "대기중"), 1)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("td", { colspan: "4" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "데이터가 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ]),
        ($setup.noCommentState.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.noCommentState.page,
              totalLength: $setup.noCommentState.totalLength,
              perPage: $setup.noCommentState.size,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h2", _hoisted_13, [
            _createVNode(_component_RouterLink, { to: { name: 'reportList' } }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" 시민제보 현황 ", -1),
                _createElementVNode("img", {
                  src: "img/view_more.png",
                  alt: ""
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createTextVNode(" 총 ", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString($setup.CommonUtils.numberFormat(
                                    $setup.getCntByCn(0 + "", $setup.reportState.list1) +
                                        $setup.getCntByCn(1 + "", $setup.reportState.list1) +
                                        $setup.getCntByCn(1 + "", $setup.reportState.list2) +
                                        $setup.getCntByCn(2 + "", $setup.reportState.list2) +
                                        $setup.getCntByCn(3 + "", $setup.reportState.list2) +
                                        $setup.getCntByCn(4 + "", $setup.reportState.list2),
                                )) + "건 ", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", null, [
            _cache[12] || (_cache[12] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"40px"} }),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"154px"} }),
              _createElementVNode("col", { style: {"width":"120px"} })
            ], -1)),
            _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "번호"),
                _createElementVNode("th", null, "게시판"),
                _createElementVNode("th", null, "분류"),
                _createElementVNode("th", null, "게시물 총건수")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportState.list1, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(idx + 1), 1),
                  _createElementVNode("td", _hoisted_18, [
                    _createVNode(_component_RouterLink, { to: { name: 'reportList', query: { type: 1 } } }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("성매매 의심 업소 제보", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.targetCol === "0" ? "학교 주변 외" : "학교주변"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("table", _hoisted_19, [
            _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "합계")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_20, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(0 + "", $setup.reportState.list1) + $setup.getCntByCn(1 + "", $setup.reportState.list1))) + "건 ", 1)
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("tr", null, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("table", null, [
            _cache[17] || (_cache[17] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"40px"} }),
              _createElementVNode("col", { style: {"width":"170px"} }),
              _createElementVNode("col", { style: {"width":"154px"} }),
              _createElementVNode("col", { style: {"width":"120px"} })
            ], -1)),
            _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "번호"),
                _createElementVNode("th", null, "게시판"),
                _createElementVNode("th", null, "분류"),
                _createElementVNode("th", null, "게시물 총건수")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportState.list2, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(idx + 1), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createVNode(_component_RouterLink, { to: { name: 'reportList', query: { type: 2 } } }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("성매매 알선 광고 제보", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.targetCol === "1"
                                        ? "온라인알선광고"
                                        : item.targetCol === "2"
                                        ? "지면광고"
                                        : item.targetCol === "3"
                                        ? "불법 옥외 광고물"
                                        : "기타"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("table", _hoisted_24, [
            _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "합계")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_25, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.getCntByCn(1 + "", $setup.reportState.list2) +
                                            $setup.getCntByCn(2 + "", $setup.reportState.list2) +
                                            $setup.getCntByCn(3 + "", $setup.reportState.list2) +
                                            $setup.getCntByCn(4 + "", $setup.reportState.list2),
                                    )) + "건 ", 1)
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("tr", null, null, -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "box_tit _flex" }, [
          _createElementVNode("h2", null, "접속자 현황")
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.visitHistoryState.startDate) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.getVisitHistory && $setup.getVisitHistory(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.visitHistoryState.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.visitHistoryState.endDate) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.getVisitHistory && $setup.getVisitHistory(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.visitHistoryState.endDate]
                  ])
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "graph_info" }, "*최근 1년까지 검색 가능합니다.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            ($setup.visitHistoryState.isDraw)
              ? (_openBlock(), _createBlock(_component_Chart, {
                  key: 0,
                  titlePadding: $setup.visitHistoryState.titlePadding,
                  data: $setup.visitHistoryState.data,
                  legendPosition: $setup.visitHistoryState.legendPosition,
                  width: $setup.visitHistoryState.chartWidth,
                  height: $setup.visitHistoryState.chartHeight,
                  title: $setup.visitHistoryState.title,
                  subTitle: $setup.visitHistoryState.subTitle
                }, null, 8, ["titlePadding", "data", "legendPosition", "width", "height", "title", "subTitle"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "box_tit _flex" }, [
            _createElementVNode("h3", null, "Daily (일간)"),
            _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("div", null, "최근 6일간")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("table", null, [
              _cache[23] || (_cache[23] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"160px"} }),
                _createElementVNode("col")
              ], -1)),
              _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "날짜"),
                  _createElementVNode("th", null, "접속자")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                ($setup.visitHistoryRecentState.list1 && $setup.visitHistoryRecentState.list1.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.visitHistoryRecentState.list1, (item) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYYMMDDDay(item.targetCol, ".")), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_36, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("td", { colspan: "2" }, [
                        _createElementVNode("div", {
                          class: "tb_subject",
                          style: {"text-align":"center","width":"100%"}
                        }, "데이터가 없습니다.")
                      ], -1)
                    ]))]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "box_tit _flex" }, [
            _createElementVNode("h3", null, "Weekly (주간)"),
            _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("div", null, "최근 6주간")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("table", null, [
              _cache[27] || (_cache[27] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"160px"} }),
                _createElementVNode("col")
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "날짜"),
                  _createElementVNode("th", null, "접속자")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                ($setup.visitHistoryRecentState.list2 && $setup.visitHistoryRecentState.list2.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.visitHistoryRecentState.list2, (item) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(item.targetCol.split("~")[0], ".") +
                                            " ~ " +
                                            $setup.CommonUtils.dateFormatYYMMDD(item.targetCol.split("~")[1], ".")), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_39, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("td", { colspan: "2" }, [
                        _createElementVNode("div", {
                          class: "tb_subject",
                          style: {"text-align":"center","width":"100%"}
                        }, "데이터가 없습니다.")
                      ], -1)
                    ]))]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "box_tit _flex" }, [
            _createElementVNode("h3", null, "Monthly (월간)"),
            _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("div", null, "최근 6개월")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("table", null, [
              _cache[31] || (_cache[31] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"160px"} }),
                _createElementVNode("col")
              ], -1)),
              _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "월"),
                  _createElementVNode("th", null, "접속자")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                ($setup.visitHistoryRecentState.list3 && $setup.visitHistoryRecentState.list3.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.visitHistoryRecentState.list3, (item) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYYMM(item.targetCol, ".")), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_42, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("td", { colspan: "2" }, [
                        _createElementVNode("div", {
                          class: "tb_subject",
                          style: {"text-align":"center","width":"100%"}
                        }, "데이터가 없습니다.")
                      ], -1)
                    ]))]))
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}